import { FC, LegacyRef, memo, useRef } from 'react'
import YouTube from 'react-youtube'
import dynamic from 'next/dynamic'

import Auth from 'store/auth'
import BannerWithoutVideo from 'components/banners/banner-without-video/banner-without-video'
const NotAvaliable = dynamic(
  () => import('../../banners/banner-not-avaliable/banner-not-avaliable')
)

const BannerAuthAccess = dynamic(
  () => import('components/banners/banner-auth-access/banner-auth-access')
)

import YoutubeVideo from 'components/webinar/webinar-active/player/video/youtube-video'
import VkVideo from 'components/webinar/webinar-active/player/video/vk-video'
import RutubeVideo from 'components/webinar/webinar-active/player/video/rutube-video'
import YandexVideo from '../webinar-active/player/video/yandex-video'

import { currSeminarData } from 'constants/data'
import { checkVkLink } from 'utils/vk/vkVideoUtils'
import { checkRutubeLink } from 'utils/rutube/rutubeVideoUtils'
import { checkYaVideoLink } from 'utils/yandex/yaVideoUtils'

import styles from './video-block.module.scss'

interface IVideoFrame {
  dataset: {
    unregisteredAvailable?: boolean
    videoLink: string
    price?: number | string
    id: number | string
    materialType?: string
    recordWithoutVideo?: boolean
  }
  isMustBePaid?: boolean
  noAnalytics?: boolean
  refPlayer?: LegacyRef<YouTube>
}

const VideoFrame: FC<IVideoFrame> = ({ dataset, isMustBePaid, noAnalytics, refPlayer }) => {
  const { unregisteredAvailable, recordWithoutVideo } = dataset

  const videoRef = useRef<HTMLDivElement>(null)
  const { isAuthorized } = Auth.useAuth()

  const isContentHidden = !isAuthorized && !unregisteredAvailable
  const linkUnavailable = typeof dataset?.videoLink !== 'string' && !dataset?.videoLink

  if (recordWithoutVideo)
    return (
      <div className={styles.translation}>
        <BannerWithoutVideo wrapMod={styles.bannerAccess} />
      </div>
    )
  if (isContentHidden) {
    const txtBanner =
      dataset.materialType === 'webinar'
        ? 'Чтобы посмотреть запись вебинара'
        : 'Чтобы посмотреть видео'
    return (
      <div className={styles.translation}>
        <BannerAuthAccess txt={txtBanner} wrapMod={styles.bannerAccess} />
      </div>
    )
  }
  if (isMustBePaid) {
    const PaymentData = {
      returnUrl: `${currSeminarData.domain}/order`,
      description: 'Покупка вебинара',
      materialType: 'webinar',
      path: '/webinar',
      amount: dataset.price || '50000',
      materialId: dataset.id,
    }
    return (
      <div className={styles.translation}>
        <NotAvaliable modificator="PAID_WEBINAR" PaymentData={PaymentData} />
      </div>
    )
  }
  if (linkUnavailable) {
    return (
      <div className={styles.translation}>
        <NotAvaliable modificator="UNAVAILABLE_RECORD" />
      </div>
    )
  }

  if (checkRutubeLink(dataset.videoLink)) {
    return (
      <RutubeVideo
        videoLink={dataset.videoLink}
        materialId={dataset.id}
        materialType={dataset.materialType}
        noAnalytics={noAnalytics}
        refPlayerOuter={refPlayer}
      />
    )
  }

  if (checkVkLink(dataset.videoLink)) {
    return (
      <VkVideo
        videoLink={dataset.videoLink}
        materialId={dataset.id}
        materialType={dataset.materialType}
        noAnalytics={noAnalytics}
        refPlayerOuter={refPlayer}
      />
    )
  }

  if (checkYaVideoLink(dataset.videoLink)) {
    return (
      <YandexVideo
        videoLink={dataset.videoLink}
        materialId={dataset.id}
        materialType={dataset.materialType}
        noAnalytics={noAnalytics}
        refPlayerOuter={refPlayer}
      />
    )
  }

  return (
    <div ref={videoRef}>
      <YoutubeVideo
        videoId={dataset.videoLink}
        materialId={dataset.id}
        materialType={dataset.materialType}
        noAnalytics={noAnalytics}
        refPlayer={refPlayer}
      />
    </div>
  )
}

export default memo(VideoFrame)
